import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { useAuth } from "../../contexts/AuthContext"; // Import useAuth hook
import { showConfirmationAlert } from "../../utils/confirmationAlert"; // Import updated confirmation alert
import LanguageSwitcher from "./LanguageSwitcher";
import importImage from "../../utils/images/importImage";

const Header = () => {
  const logo = importImage("logo-dark1.png");
  const { t } = useLanguage();
  const location = useLocation();
  const { user, logout } = useAuth(); // Access user and logout from AuthContext
  console.log("user", user);

  const handleLogout = () => {
    showConfirmationAlert({
      message: t("header.confirmLogout", "Are you sure you want to logout?"),
      onConfirm: () => {
        logout();
        console.log("Logged out");
      },
      onCancel: () => {
        console.log("Logout cancelled");
      },
    });
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0 sticky-top shadow-sm">
        <Link to="/" className="navbar-brand p-0">
          {/*<h2 className="text-dark">TOKOYARN</h2>*/}
          <img
            src={logo}
            className="main-logo"
            data-wow-delay="0.9s"
            style={{ objectFit: "cover", maxWidth: "100px", maxHeight: "55px" }}
            alt="logo"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="fa fa-bars"></span>
        </button>
        <span class="cstm-nav-overlay d-lg-none collapsed" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"></span>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="nav-head d-flex d-lg-none justify-content-between px-4 py-2 border-bottom">

            <Link to="/" className="navbar-brand logo-inn-nav p-0">
              <img
                src={logo}
                className="main-logo"
                data-wow-delay="0.9s"
                style={{ objectFit: "cover", maxWidth: "100px", maxHeight: "55px" }}
                alt="logo"
              />
            </Link>

            <button
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div className="navbar-nav ml-auto py-0 mr-3">
            <Link
              to="/"
              className={`nav-item nav-link ${location.pathname === "/" ? "active" : ""
                }`}
            >
              {t("header.home")}
            </Link>
            <Link
              to="/about"
              className={`nav-item nav-link ${location.pathname === "/about" ? "active" : ""
                }`}
            >
              {t("header.about")}
            </Link>
            <Link
              to="/blogs"
              className={`nav-item nav-link ${location.pathname === "/blogs" ? "active" : ""
                }`}
            >
              {t("header.news", "News")}
            </Link>
            <Link
              to="/contact"
              className={`nav-item nav-link ${location.pathname === "/contact" ? "active" : ""
                }`}
            >
              {t("header.contact")}
            </Link>


            {/* Conditional Rendering Based on Login State */}
            {user ? (
                <>
                  {user.role === "admin" ? (
                    <>
                      <Link
                        to="/admin-dashboard"
                        className={`nav-item nav-link ${
                          location.pathname === "/admin-dashboard" ? "active" : ""
                        }`}
                      >
                        {t("header.admin", "Admin")}
                      </Link>

                      <button
                        className="nav-item nav-link btn btn-link p-0"
                        onClick={handleLogout}
                        style={{ textDecoration: "none" }}
                      >
                        {t("header.logout", "Logout")}
                      </button>
                    </>
                  ) : (
                    <>
                      <Link
                        to="/buyer-dashboard"
                        className={`nav-item nav-link ${
                          location.pathname === "/buyer-dashboard" ? "active" : ""
                        }`}
                      >
                        {t("header.buyerDashboard")}
                      </Link>

                      <Link
                        to="/seller-dashboard"
                        className={`nav-item nav-link ${
                          location.pathname === "/seller-dashboard" ? "active" : ""
                        }`}
                      >
                        {t("header.sellerDashboard")}
                      </Link>

                      <button
                        className="nav-item nav-link btn btn-link p-0"
                        onClick={handleLogout}
                        style={{ textDecoration: "none" }}
                      >
                        {t("header.logout", "Logout")}
                      </button>
                    </>
                  )}
                </>
              ) : (
              <>
                <Link
                  to="/login"
                  className={`nav-item nav-link ${location.pathname === "/login" ? "active" : ""
                    }`}
                >
                  {t("header.login", "Login")}
                </Link>
                <Link
                  to="/register"
                  className={`nav-item nav-link ${location.pathname === "/register" ? "active" : ""
                    }`}
                >
                  {t("header.register", "Register")}
                </Link>
              </>
            )}
          </div>
          <LanguageSwitcher />
        </div>
      </nav>
    </header>
  );
};

export default Header;



